<hr *ngIf="isPtrs || isToAccountTrust">
<div id="from-account" *ngIf="transactionType === 'internal-transfer' && isPtrs">{{fromAccountTitle}}</div>
<div class="row trustFieldsMargin" *ngIf="isPtrs">
    <div class="column">
        <mm-condensed-label-group id="condensed_trustIncome" data-testid="condensedPage_trustIncomeLabel" [title]="labels.trustIncomePercent" [data]="trustIncomePercent ?? ''"></mm-condensed-label-group>
    </div>
    <div class="column">
        <mm-condensed-label-group id="condensed_trustPrincipal" data-testid="condensedPage_trustPrincipalLabel" [title]="labels.trustPrincipalPercent" [data]="trustPrincipalPercent ?? ''"></mm-condensed-label-group>
    </div>
    <div class="column" *ngIf="!!trustTaxCategory">
        <mm-condensed-label-group id="condensed_trustTaxCategory" data-testid="condensedPage_trustTaxCategoryLabel" [title]="labels.trustTaxCategory" [data]="trustTaxCategory"></mm-condensed-label-group>
    </div>
    <div class="column">
        <mm-condensed-label-group id="condensed_trustTaxCode" data-testid="condensedPage_trustTaxCodeLabel" [title]="labels.trustTaxCode" [data]="trustTaxCode ?? ''"></mm-condensed-label-group>
    </div>
    <div class="column" *ngIf="((transferDirection === 'outgoing' && transactionType === 'ach') || transactionType != 'ach')">
        <mm-condensed-label-group id="condensed_trustPaidFor" data-testid="condensedPage_trustPaidForLabel" [title]="labels.trustPaidFor" [data]="trustPaidFor ?? ''"></mm-condensed-label-group>
    </div>
    <div class="column trustCommentLabel" *ngIf="trustComment && isNotEmptyOrNull(trustComment)">
        <mm-condensed-label-group id="condensed_trustComment" data-testid="condensedPage_trustCommentLabel" [title]="labels.trustComment" [data]="trustComment"></mm-condensed-label-group>
    </div>
</div>
<ng-container *ngIf="transactionType === 'internal-transfer' && displayToTrustFields">
    <div id="to-account" *ngIf="isToAccountTrust">{{toAccountTitle}}</div>
    <div class="row trustFieldsMargin">
        <div class="column" *ngIf="trustIncomeToPercent">
            <mm-condensed-label-group id="condensed-trust-income-percent" data-testid="condensedPage_trustIncomePercent"
                [title]="labels.trustIncomePercent" [data]="trustIncomeToPercent">
            </mm-condensed-label-group>
        </div>
        <div class="column" *ngIf="trustPrincipalToPercent">
            <mm-condensed-label-group id="condensed-trust-principal-percent" data-testid="condensedPage_trustPrincipalPercent"
                [title]="labels.trustPrincipalPercent"
                [data]="trustPrincipalToPercent">
            </mm-condensed-label-group>
        </div>
        <div class="column" *ngIf="depositTaxCode">
            <mm-condensed-label-group id="condensed-trust-principal-percent" data-testid="condensedPage_depositTaxCode"
                [title]="labels.depositTaxCode"
                [data]="depositTaxCode | sentenceCase">
            </mm-condensed-label-group>
        </div>
        <div class="column trustCommentLabel" *ngIf="!isPtrs && isNotEmptyOrNull(trustComment)">
            <mm-condensed-label-group id="condensed_trustComment" data-testid="condensedPage_trustCommentLabel"
                [title]="labels.trustComment" [data]="trustComment">
            </mm-condensed-label-group>
        </div>
    </div>
</ng-container>
<mm-banners *ngIf="displayPtrsBanner" [bannerText]="[viewPagePtrsInfoBannerPrimaryText]"
    [boldText]="viewPagePtrsInfoBannerBoldText" [type]="'information'" [showCloseIcon]="false"
    id="ach_condensedPage_ptrsDisclaimer" data-testid="ach_condensedPage_ptrsDisclaimer">
</mm-banners>